<template>
  <div class="markdown-container">
    <div class="markdown-body" v-html="sanitizedHtml"></div>
  </div>
</template>

<script>
// For older versions (Solution 1), these import styles are safer
import marked from 'marked'; 
import DOMPurify from 'dompurify';
import katex from 'katex';
import 'katex/dist/katex.min.css';

export default {
  name: 'BaseMarkdown',
  props: {
    content: {
      type: String,
      default: ''
    }
  },
  computed: {
    sanitizedHtml() {
      if (!this.content) return '';

      // 1. Pre-process LaTeX ($$formula$$ or $formula$)
      // Use 'gs' flags to ensure multiline formulas are captured
      let processedContent = this.content.replace(/\$\$(.*?)\$\$/gs, (match, formula) => {
        try {
          return katex.renderToString(formula, { 
            displayMode: true,
            throwOnError: false 
          });
        } catch (e) { 
          return match; 
        }
      });

      processedContent = processedContent.replace(/\$(.*?)\$/g, (match, formula) => {
        try {
          return katex.renderToString(formula, { 
            displayMode: false,
            throwOnError: false 
          });
        } catch (e) { 
          return match; 
        }
      });

      // 2. Parse Markdown 
      // In marked@4, you can call it directly or via marked.parse()
      const rawHtml = typeof marked.parse === 'function' 
        ? marked.parse(processedContent) 
        : marked(processedContent);

      // 3. Sanitize for Security
      return DOMPurify.sanitize(rawHtml);
    }
  }
};
</script>

<style scoped>
/* github-markdown-css style layout */
.markdown-body {
  box-sizing: border-box;
  min-width: 200px;
  max-width: 980px;
  margin: 0 auto;
  padding: 15px;
  line-height: 1.6;
  /* Crucial for Yoruba diacritics */
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Helvetica, Arial, sans-serif;
  color: #24292e;
}

/* Ensure math formulas don't break layout on small mobile screens */
.katex-display {
  margin: 1em 0;
  overflow-x: auto;
  overflow-y: hidden;
  padding: 8px 0;
}

/* Basic styling for tables (Common in CBT) */
.markdown-body table {
  border-spacing: 0;
  border-collapse: collapse;
  margin-top: 0;
  margin-bottom: 16px;
  width: 100%;
}
.markdown-body table th,
.markdown-body table td {
  padding: 6px 13px;
  border: 1px solid #dfe2e5;
}
</style>